import { Icon, SegmentedButton } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { COLLECTIONS_TAB } from '@hero/constants';
import { PageLayout } from '@hero/layouts';
import { CollectionTypeTable } from '@hero/molecules';
import { ROUTE_PATHS } from '@hero/routes';
import { useCreateCollection } from '@hero/services';
import { useNotification } from '@hero/store/hooks';
import { getNameFeatureFormData } from '@hero/utils';
import { getNameSchema } from '@hero/validations';

export default function CollectionsSavedPage() {
  const navigate = useNavigate();
  const { showNotification } = useNotification();
  const { t } = useTranslation();

  const { mutateAsync: createCollection } = useCreateCollection();

  const showCollectionNameModal = () => {
    showNotification({
      header: t('nameYourFeature', { name: t('collection').toLocaleLowerCase() }),
      formData: getNameFeatureFormData({
        label: t('featureName', { featureType: t('collection') })
      }),
      formValidationSchema: getNameSchema(),
      primaryButtonProps: {
        endIcon: 'next',
        children: t('next')
      },
      secondaryButtonProps: { children: t('cancel') },
      notificationImage: <Icon name="collections" size="xxl" />,
      onSubmit: async ({ formValues }) => {
        const res = await createCollection({
          name: formValues.name,
          products: []
        });
        navigate(ROUTE_PATHS.COLLECTIONS_DETAIL_EDIT(res.id));
      }
    });
  };

  const collectionOptions = [
    {
      value: COLLECTIONS_TAB.saved,
      label: t('saved'),
      path: ROUTE_PATHS.COLLECTIONS()
    },
    {
      value: COLLECTIONS_TAB.featured,
      label: t('featured'),
      path: ROUTE_PATHS.COLLECTIONS_FEATURED()
    }
  ];

  return (
    <PageLayout
      header={{
        title: t('collections'),
        createButton: {
          onClick: showCollectionNameModal,
          children: t('createNew')
        }
      }}
    >
      <SegmentedButton
        activeTab={COLLECTIONS_TAB.saved}
        onChange={tab => {
          const path = collectionOptions.find(option => option.value === tab)?.path;
          navigate(path);
        }}
        withLine
        options={collectionOptions}
        updateHash={false}
      />
      <div style={{ marginBottom: '16px' }} />
      <CollectionTypeTable activeTab={COLLECTIONS_TAB.saved} createNew={showCollectionNameModal} />
    </PageLayout>
  );
}
